import { invoke } from "@tauri-apps/api/core";
import { getCurrentWebviewWindow, WebviewWindow } from "@tauri-apps/api/webviewWindow";
import { LogicalPosition } from "@tauri-apps/api/window";
export async function clipCursorToRectangle(rect) {
    if (window.__TAURI__) {
        const webviewWindow = WebviewWindow.getCurrent();
        const windowPosition = await webviewWindow.innerPosition();
        const scaleFactor = await webviewWindow.scaleFactor();
        return invoke("clip_cursor", {
            x: Math.round(windowPosition.x + scaleFactor * rect.x),
            y: Math.round(windowPosition.y + scaleFactor * rect.y),
            width: Math.round(scaleFactor * (rect.width - 1)),
            height: Math.round(scaleFactor * (rect.height - 1)),
        });
    }
}
export async function clipCursorToWindow(offsetWidth, offsetHeight) {
    if (window.__TAURI__) {
        const webviewWindow = WebviewWindow.getCurrent();
        const windowPosition = await webviewWindow.innerPosition();
        const scaleFactor = await webviewWindow.scaleFactor();
        await invoke("clip_cursor", {
            x: Math.round(windowPosition.x),
            y: Math.round(windowPosition.y),
            width: Math.round(scaleFactor * (window.innerWidth - offsetWidth)),
            height: Math.round(scaleFactor * (window.innerHeight - offsetHeight)),
        });
    }
}
export async function setCursorPosition(x, y) {
    if (window.__TAURI__) {
        return getCurrentWebviewWindow().setCursorPosition(new LogicalPosition(x, y));
    }
}
//# sourceMappingURL=cursor.js.map